import { motion } from "framer-motion";
import { GALLERY } from "../data/site";
import { EASE } from "./shared";

export function Gallery() {
  return (
    <div className="mt-16" data-testid="gyc-gallery">
      <div className="flex items-center gap-4 mb-6">
        <span className="text-[10px] uppercase tracking-[0.3em] text-[#D4AF37]">On the Ground</span>
        <span className="h-px flex-1 bg-[#D4AF37]/15" />
        <span className="text-[10px] uppercase tracking-[0.2em] text-[#52525b]">Actual site photographs</span>
      </div>
      <div className="flex gap-4 overflow-x-auto pb-4 snap-x snap-mandatory [scrollbar-width:thin] [scrollbar-color:#D4AF37_transparent]">
        {GALLERY.map((g, i) => (
          <motion.figure
            key={g.src}
            data-testid={`gallery-item-${i}`}
            className="relative shrink-0 w-[260px] sm:w-[320px] aspect-[4/3] overflow-hidden rounded-[2px] border border-[#D4AF37]/15 snap-start group"
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-40px" }}
            transition={{ duration: 0.8, delay: i * 0.06, ease: EASE }}
          >
            <img src={g.src} alt={g.caption} loading="lazy" className="w-full h-full object-cover img-cinematic transition-transform duration-[1.4s] ease-out group-hover:scale-110" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent" />
            <figcaption className="absolute bottom-0 inset-x-0 p-4 text-[11px] uppercase tracking-[0.18em] text-[#F3E5AB]">{g.caption}</figcaption>
          </motion.figure>
        ))}
      </div>
    </div>
  );
}
